var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultWrenchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 74,
    height: 74,
    rx: 8.222,
    fill: "#F4F7F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#default_wrench_icon_svg__clip0_18182_115699)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#default_wrench_icon_svg__clip1_18182_115699)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.696 31.469a8.164 8.164 0 01-12.101 7.154L26.5 50.717a2.45 2.45 0 01-3.463-3.463l12.171-12.172a8.164 8.164 0 0110.358-11.194c-.156.109-.306.233-.446.373l-3.265 3.266a3.266 3.266 0 004.618 4.618l3.266-3.266c.14-.14.264-.289.373-.446.377.939.584 1.963.584 3.036z",
    fill: "#8A8989"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "default_wrench_icon_svg__clip0_18182_115699"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(16.406 18.406)",
    d: "M0 0h39.188v39.188H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "default_wrench_icon_svg__clip1_18182_115699"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(16.406 18.406)",
    d: "M0 0h39.188v39.188H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/default_wrench_icon.d1a43860.svg";
export { SvgDefaultWrenchIcon as ReactComponent };